import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  donationDetailInputList,
  donationNtsTypeOptions,
  donationNtsTypeOptions02,
  donationTypeOptions,
  donationTypeOptions02,
  relationOptions,
} from '../../../../common/data';

import Button from '../../../../components/common/Button';
import Typography from '../../../../components/common/Typography';
import DetailButtonSection from '../../../../components/DetailButtonSection';
import DonationDetailItem from './DonationDetailItem';
import { DonationsStyled } from '../../../../asset/styled/deductions/DonationsStyled';
import SlideRightDialog from '../../../../components/common/SlideRightDialog';
import { deleteDonationInfo, getDonationDetail, updateDonationInfo } from '../doncationSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAlertMessageFunction,
  getDeleteDialogConfig,
  handleNumberChange2,
  magamCertifyCheck,
} from '../../../../common/Util';
import { isValidate } from '../util';
import { setIsDataModified } from '../../../common/commonSlice';

/*
이름 : v.htm038
관계 : familyCode[v.htm002]
주민등록번호 : v.htmPerRegNum

국세청구분 : v.htm016
구분코드 : v.htm005
상호 : v.htm002
사업자번호 : v.htm001
기부내용 : v.htm003
기부일 : v.htm008
일련번호 : v.htm009
건수 : v.htm006
금액 : v.htm007
전년도 공제액 : v.htm027
이월된 기부금 : v.htm028
기부장려금 : v.htm031
*/

const DonationsDetail = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('deductions/donations');
  const { t: tDependents } = useTranslation('dependents');
  const { t: tCommon } = useTranslation('common');
  const relationList = relationOptions(tDependents);
  const inputList = donationDetailInputList(t);
  const ntsTypeList = donationNtsTypeOptions(t);
  const ntsTypeList02 = donationNtsTypeOptions02(t);
  const donationTypeList = donationTypeOptions(t);
  const donationTypeList02 = donationTypeOptions02(t);
  const { selectedDonationDetail, donationDetail, initDonationDetail, detailReload } = useSelector(
    state => state.donation,
  );
  const { isMagam, isCertify } = useSelector(state => state.common);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    if (selectedDonationDetail?.htmPerRegNum && detailReload == -1) {
      dispatch(getDonationDetail(selectedDonationDetail));
    } else {
      // setDataList([]);
      handelClose();
    }
  }, [selectedDonationDetail]);

  useEffect(() => {
    if (isOpen && detailReload != -1) {
      dispatch(getDonationDetail(selectedDonationDetail));
    }
  }, [detailReload]);

  useEffect(() => {
    // donationDetail 배열을 직접 map으로 변환하여 새로운 배열 생성
    const newDataList = donationDetail
      .filter(item => item.htmPDFSeq !== '')
      .map(item => ({
        ...item,
        htm016: item.htm016 === '' ? '2' : item.htm016,
        htm028: item.htm012.includes('Admin') ? '0' : item.htm028,
      }));

    setDataList(newDataList);
  }, [donationDetail]);

  const handelClose = () => {
    setDataList([]);
    onClose();
  };

  const codeList = (key, data) => {
    let list = [];
    //국세청 선택
    if (key === 'htm016') {
      list = ntsTypeList;
      // if (data.htm016 != '2') list = ntsTypeList;
      // else list = ntsTypeList02;
      //기부금 구분
    } else if (key === 'htm005') {
      if (data?.htmPerType == '0') list = donationTypeList;
      else list = donationTypeList02;
    }

    return list.map((item, index) => {
      return (
        <option key={index} value={item.value}>
          {item.label}
        </option>
      );
    });
  };

  const handleAddButton = () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    setDataList(prev => {
      const newData = [...prev];
      newData.push({
        ...initDonationDetail,
        htmPerRegNum: donationDetail[0]?.htmPerRegNum,
        htmPerType: donationDetail[0]?.htmPerType,
      });
      return newData;
    });
  };
  const handleDeleteButton = dataIndex => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    let apiDelete = false;
    dataList[dataIndex].htmSeq != '' ? (apiDelete = true) : (apiDelete = false);

    if (apiDelete) {
      let formData = [];
      formData.push({
        htmSeq: dataList[dataIndex].htmSeq,
        htmPDFSeq: dataList[dataIndex].htmPDFSeq,
      });
      const deleteConfig = getDeleteDialogConfig(tCommon, 'donation', { formData });

      dispatch(deleteConfig);
    } else {
      setDataList(prev => {
        const newData = [...prev];
        newData.splice(dataIndex, 1);
        return newData;
      });
    }
  };

  const handleChange = (e, item, dataIndex) => {
    const { name, value: inputValue } = e.target;
    let value = inputValue?.trim();

    if (item.isNumber) {
      value = handleNumberChange2(value);
    }

    //일련번호
    if (name === 'htm009' || name === 'htm001') {
      value = value.replace(/[^0-9]/g, '');
    }

    dispatch(setIsDataModified(true));
    setDataList(prevDataList => {
      const updatedDataList = [...prevDataList];
      updatedDataList[dataIndex] = {
        ...updatedDataList[dataIndex],
        [name]: value,
      };
      return updatedDataList;
    });
  };

  const handleSave = async () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    const alertMessage = getAlertMessageFunction();

    if (!isValidate(dataList, t)) {
      return;
    }
    let formData = dataList;
    try {
      const resultAction = await dispatch(updateDonationInfo({ formData })).unwrap();

      if (resultAction.resultCode === 'OK') {
        alertMessage(tCommon('alertMessage.saveSuccess'), 'success');
        onClose();
      } else {
        alertMessage(tCommon('alertMessage.saveFail'), 'error');
      }
    } catch (error) {
      alertMessage(tCommon('alertMessage.saveFail'), 'error');
      console.error('저장 중 오류 발생: ', error);
    }
  };

  return (
    <SlideRightDialog isOpen={isOpen} onClose={handelClose}>
      <DonationsStyled>
        <div className="displayFlexColumn" style={{ gap: '24px' }}>
          <div className="displayFlexColumn" style={{ gap: '8px' }}>
            <Typography variant="body2Bold" color="Primary-500">
              {t('detail.title')}
            </Typography>
            <Typography variant="subtitleBold">
              {`${donationDetail[0]?.htmPerNm || ''} (${
                relationList.find(option => option.value === donationDetail[0]?.htmPerType)
                  ?.label || ''
              })`}
            </Typography>
          </div>

          {/* 기부금 상세 입력 */}
          {dataList?.map((data, dataIndex) => {
            let disabled = false;
            if (data.htm016 != '2') disabled = true;

            return (
              <DonationDetailItem
                key={dataIndex}
                inputList={inputList}
                data={data}
                handleChange={handleChange}
                dataIndex={dataIndex}
                codeList={codeList}
                t={t}
                disabled={disabled}
                handleDeleteButton={handleDeleteButton}
              />
            );
          })}

          {/* 기부금 추가 버튼 */}
          <Button
            value={t('detail.addButton')}
            style={{ width: '100%' }}
            addButton
            color="sub"
            onClick={handleAddButton}
          />

          {/* 취소, 저장 버튼 */}
          <DetailButtonSection onSave={handleSave} onClose={handelClose} />
        </div>
      </DonationsStyled>
    </SlideRightDialog>
  );
};

export default DonationsDetail;
